import React, { FC } from 'react'
import styled, { useTheme } from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'

export type Props = {
  color: string
  secondaryColor?: string
  active: boolean
  disabled?: boolean
  onClick: () => void
}

export const Color: FC<Props> = ({
  active = false,
  color = 'white',
  secondaryColor = '',
  onClick,
  disabled,
  ...restProps
}) => {
  const theme = useTheme()

  return (
    <StyledColorWrapper color={color} secondaryColor={secondaryColor} disabled={disabled} active={active}>
      <StyledColor
        active={active}
        color={color}
        secondaryColor={secondaryColor}
        onClick={onClick}
        {...restProps}
        data-active={active}
        disabled={disabled}
      >
        {getProjectName() !== 'ora' && (
          <Arrow
            xmlns="http://www.w3.org/2000/svg"
            width={theme.spacing[5]}
            height={theme.spacing[5]}
            viewBox="0 0 24 24"
            active={active}
          >
            <Path fillRule="evenodd" d="M18.087 5L8.904 15.142l-2.99-3.326L4 13.888 8.93 19 20 7.073z" />
          </Arrow>
        )}
      </StyledColor>
    </StyledColorWrapper>
  )
}

const StyledColorWrapper = styled.div<Pick<Props, 'color' | 'secondaryColor' | 'disabled' | 'active'>>`
  position: relative;
  width: ${({ theme }) =>
    getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7]}; // чтобы бордер обернул <StyledColor />
  height: ${({ theme }) =>
    getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7]}; // чтобы бордер обернул <StyledColor />
  border-width: ${({ disabled, active }) => (disabled ? `none` : active ? '2px' : '1px')};
  box-sizing: border-box;
  border-style: solid;
  // тут подставляется желтый для оры, если цвет выбран или серый, если цвет не выбран и он белый или прозрачный для всех остальных кейсов
  border-color: ${({ theme, active, color, secondaryColor }) => {
    if (active && getProjectName() === 'ora') {
      return '#FFED00'
    }
    if (
      color?.toLowerCase() === 'white' ||
      secondaryColor?.toLowerCase() === 'white' ||
      color?.toLowerCase() === '#ffffff' ||
      secondaryColor?.toLowerCase() === '#ffffff' ||
      color?.toLowerCase() === '#fff' ||
      secondaryColor?.toLowerCase() === '#fff'
    ) {
      return '#d3d3d3'
    }

    return 'transparent'
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};

  &:hover {
    border-color: ${({ theme }) => getProjectName() === 'ora' && '#FFED00'};
  }

  &::before {
    content: '';
    display: ${({ theme }) => (getProjectName() === 'ora' ? 'none' : 'block')};
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 80%;
    border-radius: 80%;
    font-size: 0;
    background-color: ${({ theme }) => theme.palette.grey[200]};
    opacity: ${({ active }) => (active ? 1 : 0)};
    transform: translate(-50%, -50%);
    transition: opacity 0.15s;
  }

  &::after {
    content: '';
    display: ${({ disabled }) => (disabled ? `block` : 'none')};
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${({ theme }) => (getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7])};
    height: ${({ theme }) => (getProjectName() !== 'avito' ? theme.spacing[6] : theme.spacing[7])};
    font-size: 0;
    transform: translate(-50%, -50%);
    background-repeat: no-repeat;
    background-size: cover;
    background-image: ${({ disabled }) =>
      disabled
        ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' transform='rotate(90 12 12)' fill='white' fill-opacity='0.8' stroke='%23BBBBBB'/%3E%3Crect x='20.1318' y='3.16113' width='1' height='24' transform='rotate(45 20.1318 3.16113)' fill='%23BBBBBB'/%3E%3C/svg%3E")`
        : 'none'};
  }
`

const StyledColor = styled.div<Props>`
  width: ${({ theme }) => (getProjectName() !== 'avito' ? '22px' : '24px')};
  height: ${({ theme }) => (getProjectName() !== 'avito' ? '22px' : '24px')};
  flex: none;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  background: ${({ color, secondaryColor }) =>
    secondaryColor ? `linear-gradient(90deg, ${color} 49%, ${secondaryColor} 51%)` : color};
  border-radius: 50%;
  border: ${({ active }) => (active && getProjectName() === 'ora' ? '2px solid #fff' : 'none')};
`

// todo: Убрать стайлед-свг и path
const Arrow = styled.svg<{ active: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  width: ${({ theme }) => theme.spacing[4]};
  height: ${({ theme }) => theme.spacing[4]};
  transform: translate(-50%, -50%);
  transition: opacity 0.15s;
  opacity: ${({ active }) => (active ? 1 : 0)};
`

const Path = styled.path`
  fill: ${({ theme }) => theme.palette.brand.primary};
`
